import { ComponentType, ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Provider components need flexible prop types
export type ProviderTuple = [ComponentType<any>, Record<string, unknown>?];

interface Props {
  providers: ProviderTuple[];
  children: ReactNode;
}

export function Providers({ providers, children }: Props) {
  let result: ReactNode = children;
  // eslint-disable-next-line unicorn/no-array-reverse -- toReversed() not available in target lib
  for (const [Provider, props = {}] of [...providers].reverse()) {
    result = <Provider {...props}>{result}</Provider>;
  }
  return <>{result}</>;
}
